import axios from 'axios'
import { API_URL } from './index'
import { CREATE_REPORT, ADD_QUILL, UPDATE_REPORT } from '../constants/ActionTypes'

//= ===============================
// POST Creation Actions
//= ===============================

const addQuill = (report_id, quill, cb, cb2) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let data = {
		story_id: report_id,
		quill: quill
	}
	
	let url = `${API_URL}/story/add/` + report_id
	axios.patch(url, data, headers)
	.then((response) => {
		console.log(response)
		cb ? cb() : null
		cb2 ? cb2(report_id) : null
	})
	.catch((error) => {
		console.log(error)
	})
}

export const createReport = (input, published, cb, cb2) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let data = {
		title: input.title,
		blurb: input.blurb,
		tags: input.tags,
		published: published
	}
	
	let url = `${API_URL}/story/create`
	axios.post(url, data, headers)
	.then((response) => {
		let report_id = response.data.story_id
		let quill = input.value
		dispatch(addQuill(report_id, quill, cb, cb2))
	})
	.catch((error) => {
		console.log(error)
	})
}

export const updateReport = (report_id, input, published, cb) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Content-Type':'application/json', 'Authorization': authorization}}
	
	let data = {
		title: input.title,
		blurb: input.blurb,
		tags: input.tags,
		published: published
	}
	
	let url = `${API_URL}/story/update/` + report_id
	axios.patch(url, data, headers)
	.then((response) => {
		let quill = input.value
		dispatch(addQuill(report_id, quill, cb))
	})
	.catch((error) => {
		console.log(error)
	})
}


// WEBPACK FOOTER //
// ./src/actions/create.js